import * as React from 'react';
import { useNavigate } from "react-router-dom";
import clsx from 'clsx';

type BackType = {
    title: string,
    className?: string
}

function  Back({ title, className }: BackType) {
    const navigate = useNavigate();

    const back = () => {
      navigate(-1)
    }

    return (
        
        <div className={clsx(
            
          className ? className : 'flex flex-col px-6 text-left pt-8 mx-auto dark:text-white'
          
        )}>
          <button onClick={e=>back()} className="relative inline-flex items-center dark:text-white">
            <svg className="w-3 h-3 me-2.5  dark:fill-white" aria-hidden="true" viewBox="0 0 24 24"><path d="M17.77 3.77 16 2 6 12l10 10 1.77-1.77L9.54 12z"></path></svg>
            <span className='text-sm font-medium dark:text-white'>{title}</span>
          </button>
        </div>
        
    )
}

export default Back